<template>
  <transition @enter="enter" @leave="leave" appear>
    <div class="Story"> 
      <div ref="container" class="Story__container"> 
        <div class="Story__background">
          <img :src="require('@/commons/img/grid.png')">
        </div>
        <Choices v-if="$root.route.to.params.section == 'story'"/>
        <Voice v-if="$root.route.to.params.section == 'voice' || $root.route.to.params.section == 'record'"/>
        <Words v-if="$root.route.to.params.section == 'words'"/>
        <Share v-if="$root.route.to.params.step == 'share'"/>
        <Finish v-if="$root.route.to.params.section == 'finish'"/>
        <BackButton v-if="$root.route.to.params.section != 'finish'"/>/>
      </div>   
    </div> 
  </transition>
</template>

<script>

import gsap from "gsap"
import Choices from '@/components/Choices.vue'
import Voice from '@/components/Voice.vue'
import Words from '@/components/Words.vue'
import Share from '@/components/Share.vue'
import Finish from '@/components/Finish.vue'
import BackButton from "./assets/BackButton.vue"

export default {

  name: 'Story',
  components: { Choices, Voice, Words, Share, Finish, BackButton },
  data: ()=>({
    sharing: null
  }),
  methods:{
    enter(el, done) {

      // console.log('enter');

      const delay = this.$root.route.from.params.section == 'weave' ? 1 : .25

      gsap.from(this.$refs.container, { 
        duration: .5, 
        y: '+=120%', 
        ease: 'cubic.out', 
        stagger: .2,
        delay: delay, 
        onComplete: ()=> done() 
      })

    },
    leave(el, done) {

      // console.log('leave');

      gsap.to(this.$refs.container, { 
        duration: .35, 
        y: '+=120%', 
        ease: 'cubic.out', 
        delay: .1, 
        onComplete: ()=> done() 
      })
    },
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Story
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  z-index 2000

  &__container

    background rgb(78, 60, 153)
    background linear-gradient(0deg, rgba(78, 60, 153, 1) 40%, rgba(32, 37, 42, 1) 100%)
    position absolute
    top 10%
    left 0
    width 100%
    height 90%
    border-top-left-radius 36px
    border-top-right-radius 36px
    overflow hidden


  &__background 
    position absolute

    & img 
      width 1312px
      max-width none
      top 0

</style>


